export default __webpack_public_path__ + "static/media/WechatIMG954.240371ef.png";